<template>
  <div>
    <slot name="updateAvailabiltyButton" />

    <v-dialog
      v-model="showAvailabilityDialog"
      persistent
      max-width="480"
    >
      <v-card class="pa-2 pt-0 pb-0">
        <v-container>
          <v-row
            no-gutters
            align="center"
          >
            <v-col class="headline">
              <span>Weekly availability</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <div>
                <p class="body-2 text--secondary">
                  Knowing your weekly availability help clients to suggest you the right project. Notice that your availability needs to be updated every 7 days. Otherwise it would be unconfirmed.
                </p>
              </div>
              <span class="subtitle-1 text--black">{{ available.label }}</span>
              <v-radio-group
                :id="available.id"
                :name="available.id"
                row
                :value="available.value"
              >
                <v-radio
                  v-for="radioBtn in available.items"
                  :key="radioBtn.text"
                  :label="radioBtn.text"
                  :value="radioBtn.value"
                  @click="updateAvailableToWorkProposal(radioBtn.value)"
                  color="darkPurple"
                />
              </v-radio-group>
              <span class="subtitle-1">{{ weeklyAvailability.label }}</span>
              <v-radio-group
                :id="weeklyAvailability.id"
                :name="weeklyAvailability.id"
                column
                :value="weeklyAvailability.value"
              >
                <v-radio
                  v-for="radioBtn in weeklyAvailability.items"
                  :key="radioBtn"
                  :label="radioBtn"
                  :value="radioBtn"
                  @click="updateWeeklyAvailability(radioBtn)"
                  color="darkPurple"
                />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row class="text-right">
            <v-col>
              <v-btn
                color="darkPurple"
                text
                @click="hideModal"
              >
                Cancel
              </v-btn>
              <v-btn
                color="darkPurple"
                @click="confirm"
                text
              >
                Confirm
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IUser } from '@/types/models/user.model'
import WeeklyAvailability from '@/assets/profile/weeklyAvailability'

interface IRadioButtonField {
  id: string
  label: string
  items: Array<any>,
  value?: string|boolean
}

@Component({
  computed: {
    ...mapGetters(['profile'])
  }
})
export default class UpdateAvailability extends Vue {
  @Prop({ default: false }) showAvailabilityDialog: boolean

  // computed
  profile: IUser
  // data
  weeklyAvailability: IRadioButtonField = {
    id: 'weeklyAvailability',
    label: 'What’s your weekly availability?',
    items: WeeklyAvailability,
  }
  available: IRadioButtonField = {
    id: 'available',
    label: 'Are you available to receive work proposals?',
    items: [{ text:'Yes', value: true }, { text:'No', value: false }],
  }

  updateAvailableToWorkProposal (value:boolean) {
    this.available.value = value
  }

  updateWeeklyAvailability (value:string) {
    this.weeklyAvailability.value = value
  }
  // methods
  hideModal () {
    this.$emit('hideModal')
  }

  confirm () {
    this.$store.dispatch('updateProfile', {
      [this.weeklyAvailability.id]: this.weeklyAvailability.value,
      [this.available.id]: this.available.value
    })
    this.hideModal()
  }

  created () {
    this.available.value = this.profile.available
    this.weeklyAvailability.value = this.profile.weeklyAvailability
  }

}
</script>
